import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { registerUser, loginUser } from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import $ from "jquery";

const SignupForm = ({ onSignupSuccess, onBack }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    agreeTerms: false,
  });

  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = 'Full Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    if (formData.password !== formData.confirmPassword)
      newErrors.confirmPassword = 'Passwords do not match';
    if (!formData.agreeTerms) newErrors.agreeTerms = 'You must agree to the terms';
    return newErrors;
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const validationErrors = validate();
  //   if (Object.keys(validationErrors).length > 0) {
  //     setErrors(validationErrors);
  //     return;
  //   }

  //   // Perform signup logic here
  //   if (onSignupSuccess) onSignupSuccess();
  // };

  // Handle successful authentication (both signup with token and auto-login)
  const handleSuccessfulAuth = (userData) => {
    alert("Signup successful! You are now logged in.");

    // Close modal and clean up
    $("#profileModal").hide();
    $(".modal-backdrop").remove();
    $('body').removeClass('modal-open');
    $('body').css('padding-right', '0px');
    $('body').css('overflow', 'auto');

    // Trigger a custom event to notify navbar of login
    window.dispatchEvent(new CustomEvent('userLogin', { detail: userData }));

    // Call the onSignupSuccess callback if provided
    if (onSignupSuccess) {
      onSignupSuccess(userData);
    } else {
      navigate('/');
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }
    setLoading(true);

  try {
    const payload = {
      name: formData.fullName,
      email: formData.email,
      password: formData.password,
      phone_number: formData.phone,
    };

    const response = await registerUser(payload);
    console.log('Full signup response:', response);
    console.log('Response keys:', Object.keys(response));
    
    if (response.message === "User registered successfully") {
      // Check if signup response includes authentication token
      if (response.token || response.accessToken) {
        // Signup includes token - proceed with immediate login
        const userData = {
          email: response.email || formData.email,
          name: response.username || response.name || formData.fullName,
          token: response.token || response.accessToken,
          id: response.userId || response.id || response._id,
          phone: response.phone || formData.phone
        };

        // Store authentication data
        localStorage.setItem('accessToken', response.token || response.accessToken);
        localStorage.setItem('user', JSON.stringify(userData));
        
        console.log('Signup with token - stored user data:', userData);
        
        // Proceed with login flow
        handleSuccessfulAuth(userData);
      } else {
        // Signup successful but no token - auto-login with credentials
        console.log('Signup successful but no token - attempting auto-login');
        
        try {
          const loginResponse = await loginUser({
            email: formData.email,
            password: formData.password
          });
          
          console.log('Auto-login response:', loginResponse);
          
          if (loginResponse?.token) {
            const userData = {
              email: loginResponse.email,
              name: loginResponse.username,
              token: loginResponse.token,
              id: loginResponse.id,
            };

            // Store authentication data
            localStorage.setItem('accessToken', loginResponse.token);
            localStorage.setItem('user', JSON.stringify(userData));
            
            console.log('Auto-login successful - stored user data:', userData);
            
            // Proceed with login flow
            handleSuccessfulAuth(userData);
          } else {
            alert("Signup successful! Please login with your credentials.");
            if (onSignupSuccess) onSignupSuccess();
          }
        } catch (loginError) {
          console.error('Auto-login failed:', loginError);
          alert("Signup successful! Please login with your credentials.");
          if (onSignupSuccess) onSignupSuccess();
        }
      }
    } else {
      alert("Signup failed. Please try again.");
    }
  } catch (error) {
    console.error("Signup error:", error);
    alert(error?.response?.data?.message || error?.message || "Something went wrong during signup.");
  }
  finally {
      setLoading(false);
    }
};


  return (
    <form className="signupForm updated-form p-4" onSubmit={handleSubmit}>
      <h4 className="text-center flex-grow-1 mb-0">Sign Up with email</h4>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <button
          type="button"
          className="btn btn-link text-decoration-none"
          onClick={onBack}
        >
          ← Back
        </button>
      </div>

      <div className="mb-3">
        <label className="form-label">Full Name</label>
        <input
          type="text"
          name="fullName"
          className="form-control"
          placeholder="Enter your full name"
          value={formData.fullName}
          onChange={handleChange}
          required
        />
        {errors.fullName && <div className="text-danger">{errors.fullName}</div>}
      </div>

      <div className="mb-3">
        <label className="form-label">Email</label>
        <input
          type="email"
          name="email"
          className="form-control"
          placeholder="Enter email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        {errors.email && <div className="text-danger">{errors.email}</div>}
      </div>

      <div className="mb-3">
        <label className="form-label">Phone (optional)</label>
        <input
          type="tel"
          name="phone"
          className="form-control"
          placeholder="Enter phone number"
          value={formData.phone}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Password</label>
        <div className="position-relative">
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            className="form-control"
            placeholder="Enter password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <span
            className="position-absolute top-50 end-0 translate-middle-y me-3"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowPassword(!showPassword)}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </span>
        </div>
        {errors.password && <div className="text-danger">{errors.password}</div>}
      </div>

      <div className="mb-3">
        <label className="form-label">Confirm Password</label>
        <input
          type="password"
          name="confirmPassword"
          className="form-control"
          placeholder="Confirm your password"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
        />
        {errors.confirmPassword && (
          <div className="text-danger">{errors.confirmPassword}</div>
        )}
      </div>

      <div className="mb-3 form-check">
        <input
          type="checkbox"
          name="agreeTerms"
          className="form-check-input"
          checked={formData.agreeTerms}
          onChange={handleChange}
        />
        <label className="form-check-label">
          I agree to the <a href="#">Terms & Conditions</a>
        </label>
        {errors.agreeTerms && (
          <div className="text-danger">{errors.agreeTerms}</div>
        )}
      </div>

      {/* Submit Button */}
      <button type="submit" className="btn btn-primary w-100" disabled={loading}>
        {loading ? (
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        ) : null}
        {loading ? 'Signing up...' : 'Sign Up'}
      </button>
    </form>
  );
};

export default SignupForm;
